<template>
  <div class="policy" :class="[
    !pendencyLoading
      ? (this.reversedReplies[0] && this.reversedReplies[0].status
        ? `pendency--status--${this.reversedReplies[0].status.id}`
        : `pendency--status--${this.status.id}`)
      : null,
    { 'policy--expanded': showMoreDetails },
  ]">

    <Loading v-if="pendencyLoading" />
    <template v-else>
      <div class="row row--policy box box--default" :class="{ 'row--active': showMoreDetails }">
        <div class="row__data row__data--medium row__data ">
          {{ pendency.id }}
        </div>
        <div class="row__data row__data--medium row__data--fixed"
          :class="{ 'row__data--underline': $checkRolePermission('pendency_edit') }">
          <span v-if="$checkRolePermission('pendency_edit')" @click="showStatusPopup = true" style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showStatusPopup" @togglePopup="showStatusPopup = $event" :items="statuses"
                :selected="pendencyStatus" :label="'name'" @submit="updatePendencyStatus($event)" />
            </transition>
            {{ status.name_de }}
          </span>

          <span v-else>
            {{ status.name_de }}
          </span>
        </div>

        <div class="row__data row__data--large row__data ">
          <p v-if="this.policy && this.policy.policy_number !== null">
            {{ this.policy.policy_number }}
          </p>
          <p v-else>
            ----
          </p>
        </div>

        <div class="row__data row__data--large row__data ">
          <p v-if="this.policy">{{ formatDate(this.policy.created_at) }}</p>
        </div>

        <div class="row__data row__data--large policy__company">

          <p>{{ company }}</p>
        </div>
        <div class="row__data row__data--large">
          {{ branch }}
        </div>
        <div class="row__data row__data--medium"
          :class="{ 'row__data--underline': $checkRolePermission('pendency_edit') }">
          <span v-if="$checkRolePermission('pendency_edit')" @click="showAgentPopup = true;" style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showAgentPopup" @togglePopup="showAgentPopup = $event" :items="agents"
                :selected="agent" :position="'left'" :label="['first_name', 'last_name']"
                @submit="updatePolicyAgent($event)" />
            </transition>
            {{ agent }}
          </span>

          <span v-else>
            {{ agent }}
          </span>
        </div>

        <div class="row__data row__data--medium row__data--half row__data--last">
          <div class="row__data row__data--small row__data--pdf icon"
            :class="hasFiles ? 'icon__pdf--active' : 'icon__pdf'" @click="openPendencyFilesModal()"></div>

          <div class="row__data row__data--small row__data--more" :class="{ 'row__data--rotate': showMoreDetails }"
            @click="showMoreDetails = !showMoreDetails">
          </div>
        </div>
      </div>
      <div class="policy__services" :class="{ 'policy__services--expand': showMoreDetails }">

        <div class="services" ref="services" :style="showMoreDetails
          ? { maxHeight: `${manualHeight}px` }
          : { maxHeight: 0 }
          " :class="{ 'services--expand': showMoreDetails }">
          <div class="services__no-data" v-if="!pendency">
            {{ $t(`pendenciesTable.${"noServicesMsg"}`) }}
          </div>
          <template v-else>
            <div class="table__header table__header--inner">
              <div class="table__label table__label sender-label">
                {{ $t(`pendenciesTable.${"sender"}`) }}
              </div>

              <div class="table__label table__label beschreibung-label">
                {{ $t(`pendenciesTable.${"description"}`) }}
              </div>

              <div class="table__label table__label deadline-reciever-label medium-label">
                {{ $t(`pendenciesTable.${"deadline"}`) }} / {{ $t(`pendenciesTable.${"receiver"}`) }}
              </div>

              <div class="table__label table__label status-label medium-label">
                {{ $t(`pendenciesTable.${"status"}`) }}
              </div>

              <div class="table__label table__label tools-label "> {{ $t(`pendenciesTable.${"tools"}`) }}</div>

              <div class="table__label table__label dropdown-label"></div>
            </div>

            <PendencyService :service="pendency" :replies="pendency.replies" :policy="pendency.policy"
              :agent="pendency.agent" :created="pendency.created_at" :description="pendency.description"
              :deadline="pendency.deadline" :receiver="pendency.customer" :status="pendency.status" :offer="offer"
              @toggle-replies="recalculateHeight" />
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import statics from "@/statics";
import PendencyService from "@/components/AccountDetails/PendencyService";
import PopupEditer from "@/partials/PopupEditer";
import Loading from "@/partials/Loading";
export default {
  name: "Pendency",

  components: {
    PendencyService,
    PopupEditer,
    Loading,
  },

  props: {
    pendency: {
      required: true,
      type: Object,
    },
    statuses: {
      required: true,
      type: Array
    },
    agents: {
      required: false,
      type: Array
    },
    expandedPendencyId: {
      type: Number,
      required: false,
    },
    offer: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      showMoreDetails: false,
      showStatusPopup: false,
      showAgentPopup: false,
      pendencyLoading: false,
      manualHeight: 0,
    };
  },

  computed: {

    reversedReplies() {
      return [...this.pendency.replies].reverse();
    },

    company() {
      return this.policy
        ? this.policy.company.full_name || statics.empty
        : statics.empty;
    },

    branch() {
      if (this.policy && this.policy.policy_services.length) {
        return this.policy.policy_services[0].service.branch_category.name || statics.empty;
      }
      return null;
    },

    agent() {
      return this.pendency
        ? `${this.pendency.agent.first_name || statics.empty} ${this.pendency.agent
          .last_name || statics.empty}`
        : statics.empty;
    },

    services() {
      return this.pendency.pendencyService.length
        ? this.pendency.pendencyService
        : [];
    },

    servicesHeight() {
      if (this.$refs.services) {
        return [...this.$refs.services.children].reduce(
          (acc, child) => acc + child.clientHeight,
          0
        );
      } else {
        return null;
      }
    },

    policy() {
      return this.pendency.policy
    },

    status() {
      return this.pendency.status
    },

    pendencyStatus() {
      return this.pendency.status
        ? this.pendency.status.name
        : statics.empty;
    },
    pendencyStatusColor() {
      return this.policy ?
        statics.policyStatuses[
          statics.policyStatuses.findIndex(
            (status) => this.policy.company.status === status.id
          )
        ].name
        : null;
    },

    hasFiles() {
      const pendencyHas = this.pendency && this.pendency.files && this.pendency.files.length;

      let offerHas = false;
      if (this.offer) {
        if (Array.isArray(this.offer)) {
          offerHas = this.offer.some((o) => o && o.files && o.files.length);
        } else {
          offerHas = this.offer.files && this.offer.files.length;
        }
      }

      return !!(pendencyHas || offerHas);
    },
  },
  watch: {
    servicesHeight(newValue) {
      this.servicesHeight = newValue;
    },
  },


  mounted() {
    this.manualHeight = [...this.$refs.services.children].reduce(
      (acc, child) => acc + child.clientHeight,
      0
    );

    if (this.pendency.id == this.expandedPendencyId) {
      this.showMoreDetails = true;
    }
  },

  methods: {
    recalculateHeight() {
      this.$nextTick(() => {
        const height = this.$refs.services.scrollHeight;
        this.manualHeight = height;
      });
    },
    async updatePendencyStatus(pendencyStatusId) {
      this.pendencyLoading = true;
      const pendency = await this.$store.dispatch("updatePendencyStatus", {
        pendencyId: this.pendency.id,
        pendencyStatusId,
      });
      this.pendency = pendency;

      this.showStatusPopup = false;
      this.pendencyLoading = false;
    },
    formatDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },

    openPendencyFilesModal() {
      const files = [];

      if (this.pendency.files && Array.isArray(this.pendency.files)) {
        files.push(...this.pendency.files);
      }

      const addOfferFiles = (offer) => {
        if (!offer || !offer.id) return;

        files.push({
          id: `${offer.policy_offer_code}-Offerte_${offer.id}`,
          name: `${offer.policy_offer_code}-Offerte.pdf`,
          file_name: `${offer.policy_offer_code}-Offerte.pdf`,
          created_at: offer.created_at,
          isDownloadable: true,
          offerId: offer.id,
        });

        if (offer.files && Array.isArray(offer.files)) {
          files.push(...offer.files);
        }
      };

      const offerItems = Array.isArray(this.offer) ? this.offer : this.offer ? [this.offer] : [];
      if (offerItems.length) {
        offerItems.forEach(addOfferFiles);
      }

      this.$store.commit("setFilesToEditId", this.pendency.id);
      this.$store.commit("setFilesToEdit", files);
      this.$store.commit("setFilesToEditOffers", offerItems);
      this.$store.commit("setFilesEditMode", 'Pendencies');
      this.$store.commit("setShowFilesEditModal", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  &__header {
    padding-left: 15px;
  }

  &__label {
    padding: 0;
    text-align: left;
  }
}

.sender-label {
  width: 22%;
}

.beschreibung-label {
  width: 35%;
}

.medium-label {
  width: 14%;
  text-align: center;
}

.tools-label {
  width: 12%;
  text-align: center;
}

.dropdown-label {
  width: 3%;
}



.pendency--status--1::before {
  background-color: #ff3333;
}

.pendency--status--2::before {
  background-color: #FF9E0F;
}

.pendency--status--3::before {
  background-color: #22db8e;
}
</style>
